import { useTranslation } from 'react-i18next';
import { ChevronIcon } from './Icons';

interface PaginationProps {
  page: number;
  hasPrev: boolean;
  hasNext: boolean;
  busy?: boolean;
  onPrev: () => void;
  onNext: () => void;
}


export function Pagination({ page, hasPrev, hasNext, busy = false, onPrev, onNext }: PaginationProps) {
  const { t } = useTranslation('common');
  if (!hasPrev && !hasNext) return null;

  return (
    <nav className="pagination" aria-label={t('pagination.label')}>
      <button
        type="button"
        className="button pagination__btn"
        disabled={!hasPrev || busy}
        onClick={() => {
          onPrev();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        <ChevronIcon size={18} className="pagination__chevron" />
        {t('pagination.prev')}
      </button>
      <span className="pagination__status" aria-live="polite">
        {t('pagination.page', { page: page + 1 })}
      </span>
      <button
        type="button"
        className="button pagination__btn"
        disabled={!hasNext || busy}
        onClick={() => {
          onNext();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        {t('pagination.next')}
        <ChevronIcon size={18} className="pagination__chevron pagination__chevron--prev" />
      </button>
    </nav>
  );
}
